import cytoscape from "cytoscape";

function generateId(type = "node", length = 6) {
  return (
    type +
    "-" +
    [...Array(length)]
      .map(() => Math.floor(Math.random() * 16).toString(16))
      .join("")
  );
}

let labelVisible = true;

let cy = cytoscape({
  container: document.getElementById("cy"),
  style: [
    {
      selector: "node[label]",
      style: {
        label: "data(label)",
        shape: "data(shape)",
      },
    },
    {
      selector: "node.selected",
      style: {
        "background-color": "#034748",
      },
    },
    {
      selector: "node.highlighted",
      style: {
        "background-color": "#71C57E",
      },
    },
    {
      selector: "edge.highlighted",
      style: {
        "line-color": "#71C57E",
      },
    },
  ],
});

cy.on("select", "node", function (event) {
  event.target.removeClass("highlighted");
  event.target.neighborhood(":unselected").addClass("highlighted");
});

cy.on("unselect", "node", function (event) {
  event.target.neighborhood(":unselected").removeClass("highlighted");
});

cy.on("cxttap", "node", function (event) {
  const name = prompt("Enter new name");
  if (name == null) {
    return;
  }
  event.target.data("label", name);
});

cy.on("cxttap", function (event) {
  if (event.target !== cy) {
    return; // prevent event bubbling
  }
  const name = prompt("Enter node name");
  if (name == null) {
    return;
  }
  cy.add({
    data: {
      id: generateId(),
      label: name,
      shape: "ellipse",
    },
    position: {
      x: event.renderedPosition.x,
      y: event.renderedPosition.y,
    },
  });
});

document
  .getElementById("csv-file-input")
  .addEventListener("change", function (e) {
    const fileReader = new FileReader();
    fileReader.onload = function (event) {
      const csvData = event.target.result;
      const lines = csvData.split("\n");
      const nameToIdMapping = {};
      const records = lines
        .filter((line) => line != null && line.trim() !== "")
        .map((line) => {
          const columns = line.split(",");
          const name = columns[0].trim();
          const connectedNodes = columns[1].trim().split(";");
          const shape = columns[2].trim() == "" ? "ellipse" : columns[2].trim();
          const id = generateId();
          nameToIdMapping[name] = id;
          return { id, name, shape, connectedNodes };
        });
      cy.remove("node", "edge");
      records.forEach((record) => {
        cy.add({
          data: {
            id: record.id,
            label: record.name,
            shape: record.shape,
          },
          position: {
            x: 100,
            y: 100,
          },
        });
      });
      records.forEach((record) => {
        record.connectedNodes.forEach((connectedNode) => {
          if (connectedNode != null && connectedNode.trim() !== "") {
            cy.add({
              selectable: false,
              data: {
                id: generateId("edge"),
                source: record.id,
                target: nameToIdMapping[connectedNode],
              },
            });
          }
        });
      });
    };
    fileReader.readAsText(e.target.files[0]);
  });

document
  .getElementById("json-file-input")
  .addEventListener("change", function (e) {
    const fileReader = new FileReader();
    fileReader.onload = function (event) {
      const jsonObject = JSON.parse(event.target.result);
      cy.json(jsonObject);
    };
    fileReader.readAsText(e.target.files[0]);
  });

document.getElementById("load-csv-button").onclick = function () {
  document.getElementById("csv-file-input").click();
};

document.getElementById("load-json-button").onclick = function () {
  document.getElementById("json-file-input").click();
};

document.getElementById("rearrange-button").onclick = function () {
  cy.layout({ name: "cose", animate: false }).run();
};

document.getElementById("rearrange-selection-vertically-button").onclick =
  function () {
    const selectedNodes = cy.$(":selected");
    if (selectedNodes.length === 0) {
      return;
    }

    const offset = 50;
    const referenceNode = selectedNodes[0];
    const referenceNodePosition = referenceNode.position();

    let startY =
      referenceNodePosition.y - ((selectedNodes.length - 1) * offset) / 2;

    selectedNodes.forEach((node, index) => {
      node.position({
        x: referenceNodePosition.x,
        y: startY + index * offset,
      });
    });
  };

document.getElementById("toggle-labels-button").onclick = function () {
  labelVisible = !labelVisible;
  cy.style()
    .selector("node")
    .style("label", labelVisible ? "data(label)" : "")
    .update();
};

document.getElementById("export-json-button").onclick = function () {
  const jsonString = JSON.stringify(cy.json());
  const link = document.createElement("a");
  link.href = URL.createObjectURL(
    new Blob([jsonString], { type: "application/json" })
  );
  link.download = "network-model.json";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

document.getElementById("export-png-button").onclick = function () {
  const pngData = cy.png({
    full: true,
    bg: "white",
  });
  const link = document.createElement("a");
  link.href = pngData;
  link.download = "cytoscape-graph.png";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

document.getElementById("select-edge-neighbors-button").onclick = function () {
  const selectedNodes = cy.$(":selected");
  if (selectedNodes == null || selectedNodes.length < 1) {
    return;
  }
  selectedNodes.neighborhood(":unselected").forEach((node) => {
    if (node.neighborhood().length < 3) {
      node.select();
    }
  });
};

document.getElementById("connect-button").onclick = function () {
  const selectedNodes = cy.$(":selected");
  if (selectedNodes.length == 2) {
    const firstNodeId = selectedNodes[0].id();
    const secondNodeId = selectedNodes[1].id();
    cy.add({
      group: "edges",
      data: {
        id: `${firstNodeId}-${secondNodeId}`,
        source: firstNodeId,
        target: secondNodeId,
      },
    });
  }
};

document.getElementById("disconnect-button").onclick = function () {
  const selectedNodes = cy.$(":selected");
  if (selectedNodes.length == 2) {
    const firstNodeId = selectedNodes[0].id();
    const secondNodeId = selectedNodes[1].id();
    cy.edges(`[source = "${firstNodeId}"][target = "${secondNodeId}"]`).remove();
    cy.edges(`[source = "${secondNodeId}"][target = "${firstNodeId}"]`).remove();
  }
};

document.getElementById("remove-button").onclick = function () {
  cy.$(":selected").neighborhood(":unselected").removeClass("highlighted");
  cy.$(":selected").remove();
};
